import bugsnag from "@bugsnag/js";
import classNames from "classnames";
import { FunctionComponent, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as ChevronBottom } from "@Icons/chevron-bottom.svg";
import { Section, Tile } from "@Types/pagify";
import { getLink } from "@Utils/pagify";
import "./style.scss";

export const Faq: FunctionComponent<{
  section: Section;
  tiles: Tile[];
}> = ({ section, tiles }) => {
  return (
    <div className="Faq">
      <div className="Faq-title">{section.title}</div>
      <div className="Faq-wrapper">
        {tiles.map((tile) => (
          <FaqItem key={tile.slug} tile={tile} />
        ))}
      </div>
    </div>
  );
};

const FaqItem: FunctionComponent<{ tile: Tile }> = ({ tile }) => {
  const [open, setOpen] = useState<boolean>(false);

  const intl = useIntl();
  const localeSlug = intl.locale;

  const question = tile.textBlock1 && tile.textBlock1[0].text;
  const answer =
    tile.textBlock2 &&
    tile.textBlock2.map((textBlock) => {
      return textBlock.navigationLink?.link ? (
        <a
          className="FaqItem-answer-link"
          href={getLink(textBlock.navigationLink, localeSlug)}
          key={textBlock.text}
        >
          {textBlock.text}
        </a>
      ) : (
        <span className="FaqItem-answer-text" key={textBlock.text}>
          {textBlock.text}
        </span>
      );
    });

  const answerElement = useRef<HTMLDivElement>(null);
  const answerHeight = answerElement.current && answerElement.current.scrollHeight;
  const answerStyle = { maxHeight: open ? `${answerHeight || 1000}px` : "0" };

  if (!question || !answer) {
    bugsnag.notify(new Error(`question / answer for tile ${tile.slug} not found in Faq`));
    return null;
  } else {
    return (
      <div className="FaqItem" key={tile.slug}>
        <div className="FaqItem-question" onClick={() => setOpen(!open)}>
          {question}
          <ChevronBottom style={{ transform: `rotate(${open ? 180 : 0}deg)` }} />
        </div>
        <div
          className={classNames("FaqItem-answer", { "FaqItem-answer--open": open })}
          ref={answerElement}
          style={answerStyle}
        >
          {answer}
        </div>
      </div>
    );
  }
};
